const base = 'ActionItems';

const ActionItemKeys = {
  ActionItems: `${base}`,
};

export default ActionItemKeys;
